<template>
    <v-card
            class="mx-auto"

            dark
            max-width="1000"

    >
        <v-card-subtitle style="position:absolute;top:0;right:0;" class="subheading mr-2"><i>{{get_string_from(data.MINUTES_PASSED)}}</i></v-card-subtitle>

        <div v-if="data.INITIATED===1" style="display:flex;top:0;padding-left:10px;">
            <v-card-subtitle >Du erbjöd</v-card-subtitle>
            <v-spacer></v-spacer>

        </div>
        <div v-if="data.INITIATED===0" style="display:flex;top:0;padding-top: 10px;padding-left:10px;">

            <v-avatar class="mr-1 ml-0" size="30" style="margin-top: -3px;">
                <img :src="'/api/images/users/'+counter_part+'.png'" @error="function(e){replaceByDefault(e,counter_part_name)}"  >
            </v-avatar>
            <v-chip :to="`/inventory/${counter_part}`" small label class="mr-1">{{counter_part_name}}</v-chip>
            <span style="padding-top: 0; padding-left: 0;" class="v-card__subtitle" >erbjöd</span>



            <v-spacer></v-spacer>

        </div>




        <v-card-text v-if="data.INITIATED===1" class="headline font-weight-bold" style="display:flex;overflow-x:scroll;height: 335px;overflow-y: hidden;">
            <v-spacer></v-spacer>
            <CollectionCard
                    v-for="(card,index) in i_lose"
                    :data="card"

                    :key="index"
                    :animate=false
                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"
                    v-on:clicked="collection_show=true;selected_collection_card=card"
            >

            </CollectionCard>
            <v-spacer></v-spacer>

        </v-card-text>
        <v-card-text v-if="data.INITIATED===0" class="headline font-weight-bold" style="display:flex;overflow-x:scroll;height: 335px;overflow-y: hidden;">
            <v-spacer></v-spacer>

            <CollectionCard
                    v-for="(card,index) in i_get"
                    :data="card"
                    :animate=false
                    :key="index"
                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"
                    v-on:clicked="collection_show=true;selected_collection_card=card"
            >

            </CollectionCard>
            <v-spacer></v-spacer>

        </v-card-text>
        <v-card-subtitle style="display: flex; padding-top: 6px; z-index: 10; position: relative; padding-left:10px;" v-if="data.INITIATED===1">
            <span style="padding-top: 2px; padding-right: 4px;" class="v-card__subtitle" >Mot</span>

            <v-chip link :to="`/inventory/${counter_part}`" small label class="mr-1">{{counter_part_namel}}</v-chip>
            <v-avatar class="ml-1 mr-0" size="30" style="margin-top: -3px;">
                <img :src="'/api/images/users/'+counter_part+'.png'" @error="function(e){replaceByDefault(e,counter_part_name)}"  >
            </v-avatar>




            <v-spacer></v-spacer>
        </v-card-subtitle>
        <v-card-subtitle style="display: flex;  z-index: 10; pointer-events: none; position: relative; padding-left:10px;" v-if="data.INITIATED===0">
            <span>Mot dina</span>
            <v-spacer></v-spacer>
        </v-card-subtitle>
        <v-card-text v-if="data.INITIATED===1" class="headline font-weight-bold" style="display:flex;overflow-x:scroll;height: 335px;overflow-y: hidden;">
            <v-spacer></v-spacer>


            <CollectionCard
                        v-for="(card,index) in i_get"
                        :data="card"
                        :key="index"
                        :animate=false
                        style="padding-top: 20px;"

                        :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"
                        v-on:clicked="collection_show=true;selected_collection_card=card"
                >

                </CollectionCard>
            <v-spacer></v-spacer>


        </v-card-text>
        <v-card-text v-if="data.INITIATED===0" class="headline font-weight-bold" style="display:flex;overflow-x:scroll;height: 335px;overflow-y: hidden;">
            <v-spacer></v-spacer>

            <CollectionCard
                    v-for="(card,index) in i_lose"
                    :data="card"
                    style="padding-top: 20px;"
                    :key="index"
                    :animate=false
                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"
                    v-on:clicked="collection_show=true;selected_collection_card=card"
            >

            </CollectionCard>
            <v-spacer></v-spacer>


        </v-card-text>
        <v-card-actions v-if="data.INITIATED===1" >
            <v-spacer></v-spacer>
            <v-btn @click="denyTrade" class="grow_me" tile small color="red">
                Ångra byte
            </v-btn>

            <v-spacer></v-spacer>
        </v-card-actions>

        <v-card-actions v-if="data.INITIATED===0" >
            <v-spacer></v-spacer>
            <v-btn @click="denyTrade" class="grow_me" tile small color="red">
                Neka byte
            </v-btn>
            <v-btn @click="acceptTrade"  class="grow_me" tile small color="green">
                Acceptera byte
            </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>

        <CollectioncardHolder

                :showoff=true
                :show-arrows=false

                :show=collection_show
                :card_data=selected_collection_card
                v-on:hide="collection_show=false"



        ></CollectioncardHolder>
    </v-card>
</template>

<script>
    import CollectionCard from "./CollectionCard";
    import CollectioncardHolder from "./CollectioncardHolder";
    export default {
        name: "Trade",
        props:{"data":Object},
        components:{CollectionCard,CollectioncardHolder},
        data(){
            return{
                i_get:[],
                i_lose:[],
                collection_show:false,
                selected_collection_card:null

            }
        },
        methods:{

            acceptTrade:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/accept_trade?tid='+this.data.TID;
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Byte accepterat!");
                        self.$store.dispatch("get_num_trades");
                        self.$store.dispatch("get_num_cards");

                        self.$emit("refresh")




                    }

                };
                http.send();
            },

            denyTrade:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/decline_trade?tid='+this.data.TID;
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4){
                        self.$emit("refresh");
                        self.$store.dispatch("get_num_trades");


                    }
                };
                http.send();
            },

            replaceByDefault(e,username){
                e.target.src = `/api/avatar/${username.toLowerCase()}`
            },
            get_string_from:function(min) {

                let returnstring = "";
                if (min <= 2) {
                    returnstring = "precis nu"
                } else if (min < 60) {
                    returnstring = `${parseInt(min)} minuter sedan`
                } else if (min < 120) {
                    returnstring = `1 timme sedan`
                } else if (min < 1440) {
                    returnstring = `${parseInt(min / 60)} timmar sedan`
                } else if (min < 2880) {
                    returnstring = `1 dag sedan`
                } else {
                    returnstring = `${parseInt(min / (60 * 24))} dagar sedan`
                }

                return returnstring;
            },
            getData(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_trade_data?TID='+this.data.TID;
                http.open('GET', url, true);
                this.i_get=[];
                this.i_lose=[];
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {


                    if(http.readyState === 4 && http.status === 200){
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            for(let i=0;i<data.length;i++){
                                if(data[i].SID===self.data.ME){
                                    self.i_lose.push(data[i])
                                }
                                else{
                                    self.i_get.push(data[i])

                                }
                            }
                        }

                    }

                };
                http.send();

            }
        },
        mounted:function(){
          this.getData();


        },
        computed:{
            counter_part_namel:function(){
                let namel=this.counter_part_name;
                if(namel.slice(-1)!=="s" && namel.slice(-1)!=="S" && namel.slice(-1)!=="x" && namel.slice(-1)!=="X"){
                    namel+="s"
                }
                return namel
            },

           counter_part:function(){
                if(this.data.INITIATED===1){
                    return this.data.RECEIVER;
                }
                else{
                    return this.data.SENDER;

                }
           },
            counter_part_name:function(){
                if(this.data.INITIATED===1){
                    return this.data.RECEIVER_NAME;
                }
                else{
                    return this.data.SENDER_NAME;

                }
            }

        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        width: 4px;
        height:10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #171717;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #262626;

    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:#373834;
    }
    .grow_me { transition: all .2s ease-in-out;opacity:0.7; }
    .grow_me:hover { opacity:1; }

</style>
